<span class="badge included-score-badge" [ngClass]="badgeClass" [ngbTooltip]="translatedTooltip">{{ translatedEnum }}</span>
